"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropTransform = void 0;
exports.drop = drop;
var _nodeStream = require("node:stream");
class DropTransform extends _nodeStream.Transform {
  constructor(limit, options = {}) {
    super({
      objectMode: true,
      ...options
    });
    this.limit = limit;
  }
  _transform(chunk, _encoding, callback) {
    if (this.limit > 0) {
      --this.limit;
    } else {
      this.push(chunk);
    }
    callback();
  }
}
exports.DropTransform = DropTransform;
function drop(limit) {
  return new DropTransform(limit);
}